// extracted by mini-css-extract-plugin
export default {"container":"PhotoCapturePage_container__o4Ogy","error-message":"PhotoCapturePage_error-message__jjKyY"};